<div class="d-flex flex-column justify-content-start" *ngIf="!isSizeMobile">
  <span id="side-profile-1" class="copec-rg-16">Gestores</span>

  <!-- 
    Se itera sobre el array ya filtrado (filteredAdminProfile) si el usuario es algún tipo de administrador.
    Esto simplifica dramáticamente la lógica del template, manejando la visibilidad en el TS.
  -->
  <div *ngIf="superAdmin || userAdmin">
    <div *ngFor="let profile of filteredAdminProfile">

      <!-- Grupo de Reportes (plegable tipo 'sandwich') -->
      <ng-container *ngIf="profile.isGroup; else singleItem">
        <div
          class="tab-admin-profile d-flex align-items-center justify-content-between"
          (click)="toggleReportsMenu()">

          <div class="d-flex align-items-center">
            <img class="fa-regular" [src]="profile.icon" alt="" />
            <span class="copec-lg-16 color-black ms-2">{{ profile.name }}</span>
          </div>

          <!-- Icono tipo chevron/sandwich -->
          <img
            src="/assets/icono/icon-chevron-down.svg"
            alt="toggle"
            class="chevron-toggle"
            [class.open]="reportsMenuOpen" />
        </div>

        <!-- Hijos del grupo Reportes -->
        <div *ngIf="reportsMenuOpen">
          <div
            class="tab-admin-profile-child d-flex align-items-center ps-4"
            *ngFor="let child of profile.children"
            (click)="selectTab(child.route)">

            <img class="fa-regular" [src]="child.icon" alt="" />
            <span class="copec-lg-20 color-black ms-2">{{ child.name }}</span>
          </div>
        </div>
      </ng-container>

      <!-- Item normal (incluye caso especial Segunda Aprobación) -->
      <ng-template #singleItem>
        <div
          class="tab-admin-profile d-flex align-items-center"
          (click)="selectTab(profile.route)">

          <!-- Caso especial: Segunda Aprobación (badge de notificaciones/loading) -->
          <ng-container *ngIf="profile.name === 'Segunda Aprobación'; else regularProfile">
            <img class="fa-regular" [src]="profile.icon" alt=""/>
            <span class="copec-lg-16 color-black ms-2 position-relative d-flex align-items-center">
              {{ profile.name }}

              <span class="notification-badge" *ngIf="pending_approval_loading || pending_approval > 0">
                <ng-container *ngIf="pending_approval_loading; else badgeNumber">
                  <span class="badge-spinner" aria-label="cargando" role="status"></span>
                </ng-container>
                <ng-template #badgeNumber>{{ pending_approval }}</ng-template>
              </span>
            </span>
          </ng-container>

          <!-- Otros perfiles (Configurar Segundo Aprobador y todos los demás) -->
          <ng-template #regularProfile>
            <img class="fa-regular" [src]="profile.icon" alt=""/>
            <span class="copec-lg-16 color-black ms-2">{{ profile.name }}</span>
          </ng-template>
        </div>
      </ng-template>
    </div>
  </div>
</div>